import React from "react";
import { Layout } from "components/Layout/Layout.styled";
import { Paragraph, Title } from "components/Text";
import { useSelector } from "react-redux";
import { IStore } from "constants/interfaces/store.interface";
import { Input } from "components/Input/Input.styled";

const Perfil = () => {
  const { user } = useSelector((state: IStore) => state.persistedAuthReducer);

  return (
    <Layout className="py-5">
      <div className="container justify-content-center align-content-center">
        <Title>Bienvenido {user.name}!</Title>
        <Paragraph>
          Esta página aún está en construcción. Mientras puedes visualizar tus
          datos
        </Paragraph>
        <hr className="divider" />
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3">
            <Paragraph>Nombre</Paragraph>
            <Input disabled value={user.name} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3">
            <Paragraph>Apellido Paterno</Paragraph>
            <Input disabled value={user.firstName} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3">
            <Paragraph>Apellido Materno</Paragraph>
            <Input disabled value={user.lastName} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3">
            <Paragraph>Rut</Paragraph>
            <Input disabled value={user.rut} />
          </div>
        </div>
        {user.email && user.email.length > 0 ? (
          <div className="mt-3">
            <Paragraph>Correos</Paragraph>
            {user.email.map((email, index) => (
              <div key={email + "-" + index}>
                <Input className="mb-2" disabled value={email} />
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </Layout>
  );
};

export default Perfil;
